<template>
  <v-card class="pa-4 elevation-1">
    <div class="d-flex align-center justify-space-between flex-wrap">
      <v-card-title class="text-subtitle-1 font-weight-bold pa-0">
        {{ $t('surveys.nps.breakdown_title') }}
      </v-card-title>
      <div class="d-flex align-center">
        <vue-json-to-csv
          :json-data="exportRows"
          :labels="exportLabels"
          :csv-title="exportFilename"
          separator=";"
        >
          <v-btn text small color="deep-purple lighten-1" class="mr-2" :disabled="!rows.length">
            <v-icon left small>mdi-download</v-icon>
            {{ $t('surveys.export.button') }}
          </v-btn>
        </vue-json-to-csv>
        <v-btn-toggle v-model="dimension" mandatory dense color="deep-purple lighten-1">
          <v-btn value="school" small>{{ $t('surveys.nps.by_school') }}</v-btn>
          <v-btn value="country" small>{{ $t('surveys.nps.by_country') }}</v-btn>
        </v-btn-toggle>
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="rows"
      :items-per-page="10"
      class="elevation-0 mt-3"
    >
      <template v-slot:item.npsScore="{ item }">{{ formatNps(item.npsScore) }}</template>
      <template v-slot:item.averageScore="{ item }">
        {{ Number(item.averageScore || 0).toFixed(1) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv';
import { formatNpsScore } from '@/utils/nps';

export default {
  name: 'NpsBreakdownTable',
  components: { VueJsonToCsv },
  props: {
    bySchool: { type: Array, default: () => [] },
    byCountry: { type: Array, default: () => [] },
    campaignName: { type: String, default: '' },
  },
  data: () => ({ dimension: 'school' }),
  computed: {
    rows() {
      const source = this.dimension === 'school' ? this.bySchool : this.byCountry;
      return source.map((row) => ({
        ...row,
        label: (this.dimension === 'school' ? row.school : row.country) || '—',
      }));
    },
    headers() {
      return [
        { text: this.$t('surveys.nps.col_segment'), value: 'label', align: 'start' },
        { text: this.$t('surveys.nps.col_responses'), value: 'n', align: 'center' },
        { text: this.$t('surveys.nps.col_nps'), value: 'npsScore', align: 'center' },
        { text: this.$t('surveys.nps.col_average'), value: 'averageScore', align: 'center' },
      ];
    },
    exportRows() {
      return this.rows.map((row) => ({
        label: row.label,
        n: row.n,
        npsScore: this.formatNps(row.npsScore),
        averageScore: Number(row.averageScore || 0).toFixed(1),
      }));
    },
    exportLabels() {
      return {
        label: { title: this.$t('surveys.nps.col_segment') },
        n: { title: this.$t('surveys.nps.col_responses') },
        npsScore: { title: this.$t('surveys.nps.col_nps') },
        averageScore: { title: this.$t('surveys.nps.col_average') },
      };
    },
    exportFilename() {
      return `breakdown_${this.dimension}_${this.campaignName}_${new Date().toISOString().slice(0, 10)}`;
    },
  },
  methods: {
    formatNps: formatNpsScore,
  },
};
</script>
